import { env } from 'virtual:integro-env';
globalThis.__INTEGRO_ENV__ = env;
